document.addEventListener("DOMContentLoaded", function () {
  let elResult = document.getElementById('searchinput');
  elResult.addEventListener('keyup', searchResults);

  let elResultMobile = document.getElementById('searchinput_mobile');
  let elResultMobileExtra = document.getElementById('searchinput_mobile_extra');

  elResultMobile.addEventListener('keyup', searchResultsMobile);
  elResultMobileExtra.addEventListener('keyup', searchResultsMobile);

  document.getElementById('searchinput').addEventListener("keypress", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      goToSearchResults();
    }
  });

  if ($('[href="#bundle_builder"]').length > 0) {
    $('[href="#bundle_builder"]').on('click', function (e) {
      e.preventDefault();
      let targetElement = document.getElementById('bundle_builder');
      if (targetElement) {
        window.scroll({
          top: targetElement.offsetTop,
          behavior: 'smooth',
        });
      }
    });
  }

  if ($('[href="#bundle"]').length > 0) {
    $('[href="#bundle"]').on('click', function (e) {
      e.preventDefault();
      let targetElement = document.getElementById('bundle_builder');
      if (targetElement) {
        window.scroll({
          top: targetElement.offsetTop,
          behavior: 'smooth',
        });
      }
    });
  }

  window.upcartOnCartLoaded = () => {
    setCartCounterInHeader();
  }


  const navItems = document.querySelectorAll('.nav-item a');

  navItems.forEach(item => {
    item.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        const dropdown = item.nextElementSibling;
        if (dropdown) {
          const isExpanded = item.getAttribute('aria-expanded') === 'true';
          item.setAttribute('aria-expanded', !isExpanded);
          dropdown.classList.toggle('hidden', isExpanded);
          dropdown.classList.toggle('block', !isExpanded);
        }
      }
      if (event.key === 'Escape') {
        const dropdown = item.nextElementSibling;
        if (dropdown) {
          item.setAttribute('aria-expanded', 'false');
          dropdown.classList.add('hidden');
          dropdown.classList.remove('block');
          item.focus();
        }
      }
    });
  });
});

function formatProductPrice(product_price) {
  let formattedPrice = product_price / 100;
  formattedPrice = formattedPrice.toFixed(2);
  return `$${formattedPrice}`;
}

//HAMBURGER MENU
let menu = document.getElementById("menu");
let menuToggle = document.getElementById("menu-toggle");
let menuToggleExtra = document.getElementById("menu-toggle-extra");
let closeMenu = document.getElementById("close-menu");
let closeMenuExtra = document.getElementById("close-menu-extra");
let body = document.querySelector("body");
const subMenus = menu.querySelectorAll("#menu li > ul");
const backButtons = menu.querySelectorAll(".back-button");

// Open menu

menuToggle.addEventListener("click", () => {
  menu.classList.add("show");
  body.classList.add("menu-open");
  closeMenu.classList.remove("hidden");
  menuToggle.classList.add("hidden");
  document.dispatchEvent(new CustomEvent('dtc:mobileMenu::opened'));
});

menuToggleExtra.addEventListener("click", () => {
  menu.classList.add("show");
  body.classList.add("menu-open");
  closeMenu.classList.remove("hidden");
  closeMenuExtra.classList.remove("hidden");
  menuToggleExtra.classList.add("hidden");
  document.dispatchEvent(new CustomEvent('dtc:mobileMenu::opened'));
});

// Close menu

closeMenu.addEventListener("click", () => {
  menu.classList.remove("show");
  body.classList.remove("menu-open");
  closeMenu.classList.add("hidden");
  menuToggle.classList.remove("hidden");
  closeAllSubmenus();
  closeSearchModal();
});

closeMenuExtra.addEventListener("click", () => {
  menu.classList.remove("show");
  body.classList.remove("menu-open");
  closeMenuExtra.classList.add("hidden");
  menuToggleExtra.classList.remove("hidden");
  closeAllSubmenus();
  closeSearchModal();
});

function closeAllSubmenus(except) {
  subMenus.forEach((sub) => {
    if (sub !== except) {
      sub.classList.remove("show-sub");
    }
  });
}

subMenus.forEach((sub) => {
  const parent = sub.parentElement;
  const parentName = parent.querySelector(".parent-name");

  parent.addEventListener("click", function (e) {
    e.preventDefault();
    sub.classList.add("show-sub");

    parentName.innerHTML = parent.querySelector("span").innerHTML;
  });

  const backButtons = document.querySelectorAll(".back-button");
  backButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.stopPropagation();
      const parentSubMenu = button.closest("ul");
      parentSubMenu.classList.remove("show-sub");
    });
  });
});

function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

// HOVER DROPDOWN

function selectVariantForCart(colorName, productId) {
  let selectElement = document.getElementById(`select_variant_id_${productId}`);
  let strikethroughSubscription = 0;
  let strikethroughOneTime = 0;
  let strikethroughSubscriptionSave = 0;
  let strikethroughOneTimeSave = 0;
  let discountPrice = 0;
  let variantPrice = 0;
  let variantComparePrice = 0;
  let variantManualSoldOut = false;
  let variantDisableStockNotificationBtn = false;

  if (typeof selectElement.options != 'undefined') {
    let options = selectElement.options;
    for (let i = 0; i < options.length; i++) {
      options[i].removeAttribute('selected');
    }
  }

  let selectedOption = selectElement.querySelector(`option[data-variant-option1="${colorName}"]`);
  if (selectedOption) {

    strikethroughOneTime = selectedOption.getAttribute('data-strikethrough-one-time');
    strikethroughOneTimeSave = selectedOption.getAttribute('data-strikethrough-one-time-save');
    strikethroughSubscription = selectedOption.getAttribute('data-strikethrough-subscription');
    strikethroughSubscriptionSave = selectedOption.getAttribute('data-strikethrough-subscription-save');
    discountPrice = selectedOption.getAttribute('data-discount-price');
    variantPrice = selectedOption.getAttribute('data-variant-price-not-formated');
    variantComparePrice = selectedOption.getAttribute('data-variant-compare_at_price-not-formated');
    variantManualSoldOut = selectedOption.getAttribute('data-variant-manual-sold-out');
    variantDisableStockNotificationBtn = selectedOption.getAttribute('data-variant-disable-stock-notify-button');

    if(variantDisableStockNotificationBtn == '') {
      variantDisableStockNotificationBtn = false;
    }

    initManualSoldOut(variantManualSoldOut);
    initDisableStockNotificationBtn(variantDisableStockNotificationBtn, variantManualSoldOut);

    showDiscountPriceForVariant(strikethroughOneTime, strikethroughSubscription, discountPrice, variantPrice, strikethroughSubscriptionSave, strikethroughOneTimeSave, variantComparePrice);

    selectedOption.setAttribute('selected', 'true');
  }
}

function selectVariantForCartWithSize(colorName, sizeName, productId) {
  let selectElement = document.getElementById(`select_variant_id_${productId}`);
  let strikethroughSubscription = 0;
  let strikethroughSubscriptionSave = 0 ;
  let strikethroughOneTime = 0;
  let strikethroughOneTimeSave = 0;
  let discountPrice = 0;
  let variantPrice = 0;
  let variantComparePrice = 0;
  let variantManualSoldOut = false;
  let variantDisableStockNotificationBtn = false;

  if(typeof  selectElement.options != 'undefined') {
    let options = selectElement.options;
    for (let i = 0; i < options.length; i++) {
      options[i].removeAttribute('selected');
    }
  }



  $(`#select_variant_id_${productId} option`).each(function(){
    let product_color = $(this).data('variant-option1');
    let product_size = $(this).data('variant-option2');

    if (product_color == colorName && product_size == sizeName) {
      $(this).attr('selected', 'selected');

      strikethroughOneTime = $(this).data('strikethrough-one-time');
      strikethroughOneTimeSave = $(this).data('strikethrough-one-time-save');
      strikethroughSubscription = $(this).data('strikethrough-subscription');
      strikethroughSubscriptionSave = $(this).data('strikethrough-subscription-save');
      discountPrice = $(this).data('discount-price');
      variantPrice = $(this).data('variant-price-not-formated');
      variantComparePrice = $(this).data('variant-compare_at_price-not-formated');
      variantManualSoldOut = $(this).data('variant-manual-sold-out');
      variantDisableStockNotificationBtn = $(this).data('variant-disable-stock-notify-button');

      if(variantDisableStockNotificationBtn == '') {
        variantDisableStockNotificationBtn = false;
      }

      initManualSoldOut(variantManualSoldOut);
      initDisableStockNotificationBtn(variantDisableStockNotificationBtn, variantManualSoldOut);

      showDiscountPriceForVariant(strikethroughOneTime, strikethroughSubscription, discountPrice, variantPrice, strikethroughSubscriptionSave, strikethroughOneTimeSave, variantComparePrice);
    }
  });
}



function initDisableStockNotificationBtn(variantDisableStockNotificationBtn, variantManualSoldOut) {

  if(variantManualSoldOut == true) {
    if (variantDisableStockNotificationBtn == true) {
      $('#stock-notification-btn, #stock-notification-btn .klaviyo-bis-trigger').hide();
    } else {
      $('#stock-notification-btn, #stock-notification-btn .klaviyo-bis-trigger').show();
      $('.pdp-main-sold-out-btn').hide();
    }
  } else {
      $('#stock-notification-btn, #stock-notification-btn .klaviyo-bis-trigger').hide();
  }
}

function initManualSoldOut(variantManualSoldOut) {
  if(variantManualSoldOut == true || variantManualSoldOut == 'true') {
    $('.pdp-main-add-to-cart-btn').hide();

    if($('#stock-notification-btn').length > 0){
      setTimeout(function() {
        $('#stock-notification-btn, #stock-notification-btn .klaviyo-bis-trigger').show();
      }, 500);
    } else {
      $('.pdp-main-sold-out-btn').show();
    }
  } else {
    $('.pdp-main-add-to-cart-btn').show();
    $('.pdp-main-sold-out-btn, #stock-notification-btn .klaviyo-bis-trigger').hide();
  }
}

function showDiscountPriceForVariant(strikethroughOneTime, strikethroughSubscription, discountPrice, variantPrice, strikethroughSubscriptionSave, strikethroughOneTimeSave, variantComparePrice) {

  let enableCustomPriceVariant = $('#enable-custom-price-variant').val();
  if(enableCustomPriceVariant == 0){
    return false;
  }

  let podsQuantity = '';
  if($('.size-option-selector--active')) {
    podsQuantity = $('.size-option-selector--active').data('pods-quantity');
  }
  if(strikethroughSubscription != 0 ) {
    $('#product-variant-discount-price-custom, #price-per-load-active-discount').remove();

    if(podsQuantity!='') {
      let podsPrice = strikethroughSubscription / podsQuantity;
      podsPrice = createMoneyFromNumber(podsPrice);
      $('.subscribe-price-per-load').hide().after(`<span id="price-per-load-active-discount">${podsPrice}</span>`);
    }

    $('#product-variant-discount-price').hide().after(
        `<div id="product-variant-discount-price-custom" class="text-right"><span class="line-through text-[#9a9a9a] pr-2">${createMoneyFromNumber(discountPrice)}</span>
        <span class="text-[#117E39]">${createMoneyFromNumber(strikethroughSubscription)}</span><div class="text-[#117E39] font-Inter text-xs">(You save ${createMoneyFromNumber(strikethroughSubscriptionSave)})</div></div>`
    );
  }else{
    $('#product-variant-discount-price-custom, #price-per-load-active-discount').remove();
    $('#product-variant-discount-price, .subscribe-price-per-load').show();
  }

  if(strikethroughOneTime != 0 ) {
    let oldPrice = variantPrice;
    if(podsQuantity!='') {
      let podsPrice = strikethroughOneTime / podsQuantity;
      podsPrice = createMoneyFromNumber(podsPrice);
      $('#price-per-load-active-discount-one-time').remove();
      $('.one-time-price-per-load').hide().after(`<span id="price-per-load-active-discount-one-time">${podsPrice}</span>`)
    }

    if(variantComparePrice > 0) {
      oldPrice = variantComparePrice;
    }

    let dtcMultipackOffer = $('#dtc-multipack-offers_price');
    if(dtcMultipackOffer.length > 0){
      dtcMultipackOffer.removeClass('line-through');
      dtcMultipackOffer.empty().html(`<div class="text-right"><span class="line-through text-[#9a9a9a] pr-2">${createMoneyFromNumber(oldPrice)}</span><span class="text-[#117E39]">${createMoneyFromNumber(strikethroughOneTime)}</span><div><span class="text-[#117E39] font-Inter text-xs">(You save ${createMoneyFromNumber(strikethroughOneTimeSave)})</span></div></div>`);
      $('#dtc-multipack-offers_discounted_price').empty();
    }else{
      $('#product-variant-one-time-price, #dtc-multipack-offers_discounted_price').empty().html(`<div class="text-right"><span class="line-through text-[#9a9a9a] pr-2">${createMoneyFromNumber(oldPrice)}</span><span class="text-[#117E39]">${createMoneyFromNumber(strikethroughOneTime)}</span><div><span class="text-[#117E39] font-Inter text-xs">(You save ${createMoneyFromNumber(strikethroughOneTimeSave)})</span></div></div>`);
    }
  } else {
    $('#price-per-load-active-discount-one-time').remove();
    $('.one-time-price-per-load').show();
    $('#dtc-multipack-offers_price').empty();

    $('#dtc-multipack-offers_discounted_price').show().empty().text(createMoneyFromNumber(variantPrice));
  }
}

function createMoneyFromNumber(numberValue) {
  numberValue = numberValue/100;
  numberValue = numberValue.toFixed(2);
  numberValue = '$' + numberValue;
  return numberValue;
}

function goToSearchResults() {
  let search_value = document.getElementById('searchinput').value;
  document.location.href = '/search?type=product&prefix=last&q=' + search_value;
}

function searchResultsMobile() {

  openSearchModal(1);

  let search_w = this.value;
  let w_length = search_w.length;
  let new_width = 15;
  const search_line_element = document.getElementById('search_word_line');
  const search_result_block = document.getElementById('search-results');
  const search_black_icon = document.getElementById('search_black_icon');
  const main_search_inner = document.getElementById('main_search_inner');

  if (w_length > 0) {
    new_width = w_length * 22;

    let xhr = new XMLHttpRequest();
    xhr.open('GET', '/search?type=product&view=json&q=' + search_w + '&prefix=last', true);

    xhr.onload = function () {
      if (xhr.status === 200) {
        var dataHTML = xhr.responseText;
        search_result_block.innerHTML = dataHTML;
      }
    };

    xhr.send();

    search_result_block.style.display = 'block';
    search_line_element.style.display = 'inline-block';
    //search_black_icon.style.display = 'none';
    main_search_inner.style.height = '100vh';

  } else {
    search_result_block.style.display = 'none';
    search_line_element.style.display = 'none';
    //search_black_icon.style.display = 'inline-block';
    search_cancel.style.display = 'none';
    main_search_inner.style.height = 'unset';
  }
}

function searchResults() {
  let search_w = this.value;
  let w_length = search_w.length;
  let new_width = 15;
  const search_line_element = document.getElementById('search_word_line');
  const search_result_block = document.getElementById('search-results');
  const search_black_icon = document.getElementById('search_black_icon');
  const main_search_inner = document.getElementById('main_search_inner');

  if (w_length > 0) {
    new_width = w_length * 22;

    let xhr = new XMLHttpRequest();
    xhr.open('GET', '/search?type=product&view=json&q=' + search_w + '&prefix=last', true);

    xhr.onload = function () {
      if (xhr.status === 200) {
        var dataHTML = xhr.responseText;
        search_result_block.innerHTML = dataHTML;
      }
    };

    xhr.send();

    search_result_block.style.display = 'block';
    search_line_element.style.display = 'inline-block';
    //search_black_icon.style.display = 'none';
    main_search_inner.style.height = '100vh';

  } else {
    search_result_block.style.display = 'none';
    search_line_element.style.display = 'none';
    //search_black_icon.style.display = 'inline-block';
    search_cancel.style.display = 'none';
    main_search_inner.style.height = 'unset';
  }
}

function openSearchModal(search_input_mobile) {
  if (search_input_mobile) {
    let search_value = document.getElementById('searchinput_mobile').value;
    let search_value_extra = document.getElementById('searchinput_mobile_extra').value;
    if(search_value_extra!=''){
      search_value = search_value_extra;
    }
    document.getElementById('searchinput').value = search_value;
    document.getElementById('searchinput').focus();

  }

  document.getElementById('modal-search').style.display = 'block';
  document.querySelector('body').style.overflow = 'hidden';
  document.getElementById('searchinput').focus();
}

function closeSearchModal() {
  //document.getElementById('bg-opacity-search').style.display = 'none';
  document.getElementById('modal-search').style.display = 'none';
  document.querySelector('body').style.overflow = 'auto';
  document.getElementById('searchinput').value = '';
  document.getElementById('searchinput_mobile').value = '';
  document.getElementById('searchinput_mobile_extra').value = '';
  document.getElementById("close-menu").click();
}

function openSmallCart() {
  window.upcartOpenCart();
}

function setCartCounterInHeader() {
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (data) {
      $('#header-small-cart-count, #header-small-cart-count-v1-extra, #header-small-cart-count-mobile, #header-small-cart-count-mobile-v1-extra').text(data.item_count);
    }
  });

}

function initCart() {
  fetch('/cart.js')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {

        let item_counts_in_cart = data.item_count;

      })
      .catch(error => {
        alert('Error: ' + error.message);
      });

}

function changeColorProductsList(color_name) {
  $('.bundle-products-color-block').hide();
  $(`[data-bundle-products-color-block="${color_name}"]`).show();
  $('.bundle-color-selectors').removeClass('border-black').addClass('border-transparent');
  $(`[data-color-selector-name="${color_name}"]`).removeClass('border-transparent').addClass('border-black');
  $('.bundle-chosen-color-name').text(color_name);
}

function quickSubscribeCuratedBundle(variant_id) {
  let selling_plan = $(`#curated_bundle_subscribe_plan_${variant_id}`).val();
  let data = {
    id: variant_id,
    quantity: 1,
    selling_plan: selling_plan,
  };

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function () {
    },
  });
}

function quickCollectionVariantBuy(variant_id) {
  let data = {
    id: variant_id,
    quantity: 1,
  };

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function () {
    },
  });
}

function cartMembershipAddToCart() {
  if (typeof memPlanVariantId != 'undefined' && typeof memPlanSellingPlanId != 'undefined') {
    if (memPlanVariantId !== '' && memPlanSellingPlanId !== '') {
      sellingPlanAddItemToCart(memPlanVariantId, memPlanSellingPlanId);
    }
  }
}

/* START Membership Plan Functions */
function addToCartGiftProduct() {
  let variant_id = $('#selected-gift-variant-id').val();
  quickCollectionVariantBuy(variant_id);
  setTimeout(function () {
    closeJoinNavGiftPopup();
  }, 1000);
}

function sellingPlanAddItemToCart(variant_id, selling_plan_id) {
  if (variant_id) {

    checkSellingProductInCart(variant_id);

    setTimeout(function () {
      let data = {};

      data = {
        id: variant_id,
        quantity: 1,
        selling_plan: selling_plan_id,
        properties: {
          '_inveterate_subscription': true
        }
      };

      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js');
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

      xhr.onload = function () {
        if (xhr.status === 200) {
          //Action after product was added to cart
          openJoinNavGiftPopup();
        } else {
          const errorResponse = JSON.parse(xhr.responseText);
          alert(errorResponse.message + '\r\n' + errorResponse.description);
        }
      };

      xhr.onerror = function (error) {
        console.error('An error occurred:', error);
      };

      xhr.send(JSON.stringify(data));
    }, 1000);

  }
}

async function checkSellingProductInCart(variant_id) {
  fetch('/cart.js')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        let membership_already_in_cart = 0;
        if (data.item_count > 0) {
          for (let i = 0; i < data.item_count; i++) {
            if (data.items[i] && data.items[i].id) {
              if (typeof data.items[i].properties._inveterate_subscription != 'undefined') {
                if (data.items[i].properties._inveterate_subscription == true) {
                  openJoinNavGiftPopup();
                  deleteProductFromCart(variant_id);
                }
              }
            }
          }
        }
      })
      .catch(error => {
        alert('Error: ' + error.message);
      });
}

function openJoinNavGiftPopup() {
  $('.join-now-popup-overbg, .join-now-popup').show();
}

function closeJoinNavGiftPopup() {
  $('.join-now-popup-overbg, .join-now-popup').hide();
}

function deleteProductFromCart(variant_id) {
  let data = {
    'id': variant_id,
    'quantity': 0
  };
  postAjax('/cart/change.js', data, function (data) {
  });
}

function postAjax(url, data, success) {
  var params = typeof data == 'string' ? data : Object.keys(data).map(
      function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
      }
  ).join('&');

  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
  xhr.open('POST', url);
  xhr.onreadystatechange = function () {
    if (xhr.readyState > 3 && xhr.status == 200) {
      success(xhr.responseText);
    }
  };
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send(params);
  return xhr;
}

/* END Membership Plan Functions */

function initKiwiCustomCode() {
  // let kwikReferral = getLsKwikReferralKey();
  // if (kwikReferral) {
  //   if (data.properties) {
  //     data.properties._kwikreferral = kwikReferral;
  //   } else {
  //     data.properties = {
  //       "_kwikreferral": kwikReferral
  //     }
  //   }
  // }
}

function getLsKwikReferralKey() {
  let kwikReferralKey;
  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('waveLink')) {
    kwikReferralKey = urlParams.get('waveLink');
  } else {
    const cookie = document.cookie.split(';').find((row) => row.trim().startsWith("kwikReferral" + '='));
    if (cookie) {
      kwikReferralKey = cookie.split('=')[1];
    }
  }
  return kwikReferralKey;
}
